import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';

const PlatformContext = createContext();

export const usePlatform = () => {
  const context = useContext(PlatformContext);
  if (!context) {
    throw new Error('usePlatform must be used within a PlatformProvider');
  }
  return context;
};

export const PlatformProvider = ({ children }) => {
  const [platforms, setPlatforms] = useState([]);
  const [loading, setLoading] = useState(false);
  const { token, user, selectedPlatform, backendUrl } = useAuth();

  useEffect(() => {
    if (token && user) {
      fetchPlatforms();
    }
  }, [token, user]);

  const fetchPlatforms = async () => {
    if (!token) return;

    setLoading(true);
    try {
      const response = await fetch(`${backendUrl}/api/platforms`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        setPlatforms(data.platforms || []);
      } else {
        console.error('Error fetching platforms');
      }
    } catch (error) {
      console.error('Error fetching platforms:', error);
    } finally {
      setLoading(false);
    }
  };

  const getCurrentPlatform = () => {
    const current = platforms.find(p => p.id === selectedPlatform) || platforms[0] || null;
    console.log('[PlatformContext] Current platform:', current?.name, 'ID:', selectedPlatform);
    return current;
  };

  const value = {
    platforms,
    loading,
    currentPlatform: getCurrentPlatform(),
    selectedPlatform,
    refetch: fetchPlatforms,
  };

  return <PlatformContext.Provider value={value}>{children}</PlatformContext.Provider>;
};